import { render, staticRenderFns } from "./staffshuju.vue?vue&type=template&id=4cccd478&scoped=true&"
import script from "./staffshuju.vue?vue&type=script&lang=js&"
export * from "./staffshuju.vue?vue&type=script&lang=js&"
import style0 from "./staffshuju.vue?vue&type=style&index=0&id=4cccd478&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cccd478",
  null
  
)

export default component.exports